export default __webpack_public_path__ + "static/media/ic_calendar.be2e0875.svg";